import React from "react";

interface TickIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?:string;}

const TickIcon: React.FC<TickIconProps> = ({
  size = 22,
  className,
  onClick,
  color="currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M0.75 5.49839L4.848 9.59639L13.0585 1.40039"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TickIcon;
